// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PostTileVideo_wrap__cPohI","link":"PostTileVideo_link__2VYh5","video":"PostTileVideo_video__1SVuc"};